import dictionary from "../dict.json";
import { Dict } from "../types";

interface Video {
  videoId: string;
  words: string[];
  transcript: string;
}

const dict = dictionary as Dict;

const knownWords = 1000;

function Stats({ title, video }: { title: string; video: Video }) {
  // require("../transcripts/bookReview.json")
  return (
    <div className="row">
      <center>
        <h3>
          {title} - {knownWords}
        </h3>
      </center>
      <div className="card col l6 offset-l3">
        <div className="card-content">
          <p className="flow-text ">
            {video.words.map((word) => {
              console.log("word:", word);
              console.log("dict[word].rank:", dict[word].rank);
              if (dict[word].rank <= knownWords) {
                return (
                  <span
                    className="green-text
            "
                  >
                    {word}{" "}
                  </span>
                );
              } else {
                return <span>{word} </span>;
              }
            })}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Stats;
